import {initializeApp} from 'firebase/app';
import {
  NextOrObserver,
  User,
  getAuth,
  onAuthStateChanged,
  signOut
} from 'firebase/auth';
import {getDatabase} from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DB_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export const userStateListener = (callback: NextOrObserver<User>) => {
  return onAuthStateChanged(auth, callback);
};

const logoutFirebase = async () => {
  await signOut(auth);
};

const currentUser = auth.currentUser;

export const REALTIME_DB = getDatabase();
export const ATLAS_DB = 'Pilots';
export const ATLAS_TMM_DB = 'TMM_DATA';

export {auth, currentUser, logoutFirebase};
